'use strict';

var Qualaroo = require('bunsen/libraries/Qualaroo');
var qualarooOptions = require('configs/dealers/qualaroo-options');
var SV = require('server-vars');
var qualarooSurvey;

(function() {
    qualarooOptions.userId = SV.userData ? SV.userData.id : SV.sellerData.id;
    qualarooOptions.autoLoad = true;
    qualarooOptions.script = SV.qualaroo_src;
    qualarooSurvey = new Qualaroo(qualarooOptions);
})();
